import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const yooga = defineStyle({
  color: 'yGray.900',
});

const small = defineStyle({
  fontSize: 'xl',
  color: 'yGray.700',
  fontWeight: 'semibold',
});

const large = defineStyle({
  fontSize: '2xl',
  color: 'yGray.950',
  fontWeight: 'semibold',
});

export const headingTheme = defineStyleConfig({
  variants: {
    yooga,
    small,
    large,
  },
  sizes: {
    small: {
      fontSize: 'xl',
      lineHeight: 1.8,
      fontWeight: 'semibold',
    },
  },
});
